import { Field } from 'formik';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
export var Error = function (props) {
    var name = props.name;
    return (React.createElement(Field, { name: name, render: function (_a) {
            var _b = _a.form, errors = _b.errors, touched = _b.touched;
            return errors[name] && touched[name] ? (React.createElement(React.Fragment, null,
                React.createElement("small", { className: "error-message", ref: function (el) {
                        focusError(el);
                    } }, errors[name]))) : null;
        } }));
    function focusError(el) {
        var node = ReactDOM.findDOMNode(el);
        if (node) {
            ;
            node.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            });
        }
    }
};
//# sourceMappingURL=Error.js.map